import { Box, Button } from "@mui/material"
import { useAppSelector } from "../../../store/hooks/redux"
import { useEffect, useRef, useState } from "react"
import moment from "moment"

export const ModalNoneCards = (props: any) => {
  const { subscribeOnMedCard, resetMedCard, isPenalty } = props
  const { card } = useAppSelector(state => state.examReducer)
  const [timerProgress, setTimerProgress] = useState<number>(15)
  const [isActive, setIsActive] = useState<boolean>(false)

  useEffect(() => {
    setIsActive(Boolean(card !== null && !isPenalty))
  }, [card, isPenalty])
  const timerRef = useRef<any>()
  useEffect(() => {
    if (isActive && timerProgress >= 0) {
      timerRef.current = setInterval(() => {
        setTimerProgress((prev) => prev-1)
      }, 1000);
    } else if (timerProgress <= 0) {
      resetMedCard()
      setIsActive(false)
      setTimerProgress(15)
      clearInterval(timerRef.current)
    } else {
      setIsActive(false)
      setTimerProgress(15)
      clearInterval(timerRef.current)
    }
    return () => {
      clearInterval(timerRef.current);
    };
  }, [isActive, timerProgress]);
    
    return (
        <Box sx={{
            //width: '1184px',
            height: '916px', 
            backgroundColor: 'white',

            display: 'flex',
            justifyContent: 'center',
        }}>

            <Box
                sx={{
                    height: '100%',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    alignItems: 'center',
                    width: '100%',
                }}
            >
                    
                <Box>
                    <Box 
                        sx={{
                            fontFamily: 'Roboto',
                            fontWeight: '500',
                            fontSize: '30px',
                            lineHeight: '38px',
                            marginTop: '50px',
                            color: '#009FDA',
                        }}
                    >
                        Ожидайте осмотры
                    </Box>
                </Box>  

                {card !== null && !isPenalty && (
                    <Box 
                        sx={{
                            fontFamily: 'Roboto',
                            fontWeight: '400',
                            fontSize: '18px',
                            lineHeight: '38px',
                            color: '#009FDA',
                            marginTop: '24px',
                            minWidth: '80%',
                            border: '2px solid #009FDA',
                            borderRadius: '8px',
                            padding: '8px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: '12px',
                        }}
                    >
                        <Box>
                          №{card?.id}
                        </Box>
                        <Box>
                          {card?.createdAt ? new Date(moment.tz(card?.createdAt).format('YYYY/MM/DD hh:mm')).toLocaleDateString('ru-RU') : '-'}
                        </Box>
                        <Box>
                          {card?.driver?.driverName ?? '-'}
                          {/* {
                            (card?.driver?.lastname || '-') + ' ' +
                            (card?.driver?.firstname || '-') + ' ' +
                            (card?.driver?.middlename || '-')
                          } */}
                        </Box>
                        <Button
                          onClick={() => {
                            setIsActive(false)
                            subscribeOnMedCard()
                          }}
                          sx={{
                            float: 'right',
                            padding: '10px 12px',
                            backgroundColor: '#009FDA',
                            borderRadius: '4px',
                            textTransform: 'none',
                            color: 'white',
                            fontSize: '16px',
                            fontWeight: 500,
                            '&:hover': { backgroundColor: '#007DB8', boxShadow: 'none' }, boxShadow: 'none',
                            lineHeight: '16px'
                        }}
                        >
                          Принять ({timerProgress})
                        </Button>
                    </Box>   
                )}       

            </Box>

        </Box>
    )
}